import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { AuditLogModule } from 'src/components/audit-log/audit-log.module';
import { TriggerLogOverlayComponent } from './trigger-log-overlay.component';

@NgModule({
  declarations: [
    TriggerLogOverlayComponent,
  ],
  imports: [
    MatButtonModule,
    MatDialogModule,
    AuditLogModule,
  ],
  providers: [],
})
export class TriggerLogOverlayModule { }
